var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-box"},[_c('h3',{staticClass:"box-title"},[_vm._v("TAREAS POR ESTADOS")]),_vm._v(" "),_c('doughnut-chart',{attrs:{"options":_vm.options,"chart-data":_vm.datacollection}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7330bf63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/dashboard/views/charts/statusTasks.vue
// module id = null
// module chunks = 